import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bw-billboard-article-legacy',
    templateUrl: './billboard-article.component.html',
    styleUrls: ['./billboard-article.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BillboardArticleComponentLegacy  {

  constructor() { }


}
